export const userRoles = {
  Supporter: "Supporter",
  Member: "Mitglied",
  Coordinator: "Koordinator:in",
  Admin: "Administrator:in",
};
